import { graphql } from '@eluve/graphql.tada';

export const appointmentFilesFragment = graphql(`
  fragment AppointmentFiles on Appointments {
    __typename
    id
    appointmentFiles {
      __typename
      appointmentId
      fileId
      fileType
      tags {
        __typename
        id
        metadata
        createdAt
        tag {
          __typename
          id
          tag
          isSystemTag
        }
      }
      userUpload {
        __typename
        id
        status
        fileUrl
        originalFileName
        uploadedAt
        transcript {
          __typename
          id
          segmentId
          transcriptionStatus
          isFinalChunk
          appointment_segment {
            __typename
            id
            recordingStartedAt
          }
        }
      }
    }
  }
`);

export const appointmentFilesQuery = graphql(
  `
    query appointmentFiles($tenantId: uuid!, $appointmentId: uuid!) {
      appointmentsByPk(tenantId: $tenantId, id: $appointmentId) {
        ...AppointmentFiles
      }
    }
  `,
  [appointmentFilesFragment],
);
